/* ============
 * Application Actions
 * ============
 *
 * The actions available for the Application module.
 */

import * as types from './types';

export default {
  openSnackbar({ commit }, payload) {
    commit(types.OPEN_SNACKBAR, payload);
  },
  closeSnackbar({ commit }, payload) {
    commit(types.CLOSE_SNACKBAR, payload);
  },
  startLoading({ commit }) {
    commit(types.LOADING_START);
  },
  finishLoading({ commit }) {
    commit(types.LOADING_FINISH);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/application/actions.js